import loadable from '@loadable/component';

export const KiplingerSiteWrapper = loadable(
  () => import(/* webpackChunkName: "kiplinger-site" */ './KiplingerSiteWrapper'),
);
